import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Row, Card, Col, Avatar } from 'antd';
import { useTranslation } from 'react-i18next';
import { ownerPersonalInfo } from '../listContent/ownerPersonalInfo';
import { DescriptionList } from '../../../../../components';
import { useOwnerContext } from '../../../../../contexts/OwnerContext/OwnerContext';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

const OwnerPersonalInfoCards = ({ isLoading }) => {
  const { t } = useTranslation();
  const { owner } = useOwnerContext();
  const { token } = useAuthContext();

  return (
    <Card
      title={
        <CardTitle icon="user">
          {t('owners.show.owners_personal_info')}
        </CardTitle>
      }
      className="form-card"
    >
      <Row gutter={[0, 24]}>
        <Col xs={24} md={8}>
          <Skeleton active loading={isLoading} paragraph={{ rows: 5 }}>
            {owner?.photo && (
              <Avatar
                src={`${process.env.REACT_APP_API_URL}/get-file-url/${owner.photo}/${token}`}
                size={160}
              />
            )}
          </Skeleton>
        </Col>
        <Col xs={24} md={16}>
          <Skeleton active loading={isLoading} paragraph={{ rows: 5 }}>
            <DescriptionList
              data={ownerPersonalInfo(owner || {}, t)}
              translate
            />
          </Skeleton>
        </Col>
      </Row>
    </Card>
  );
};

export default OwnerPersonalInfoCards;

OwnerPersonalInfoCards.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  owner: PropTypes.shape({
    photo: PropTypes.string
  }).isRequired
};
